<template>
  <div class="menu-box">
    <div class="header">
      <div class="center_box">
        <div
          v-if="
            ($route.path === '/FloorHome' && menuState) ||
            ($route.path === '/FloorBannerPage' && menuState)
          "
          class="logo_floor"
          @click="jump('/')"
        >
          <!-- <img
            src="../assets/components_img/floor_logo.png"
            class="img_cover"
            alt=""
          /> -->
          <img
            src="../assets/components_img/floor_logo3.png"
            class="img_cover"
            alt=""
            style="object-fit: contain"
          />
        </div>
        <!-- <div
          v-if="$route.path === '/FloorBannerPage' && "
          class="logo"
          @click="jump('/')"
        >
          <img
            src="../assets/indexImg/black_logo.png"
            class="img_cover"
            alt=""
          />
        </div> -->
        <div v-else class="logo" @click="jump('/')">
          <img
            :src="tianyuanLogo"
            class="img_cover"
            alt=""
          />
        </div>
        <div class="list_box">
          <div @click="menuSwitch" class="menu-but">
            <span class="menu-but1"></span>
            <span class="menu-but2"></span>
            <span class="menu-but3"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-content">
      <!--菜单-->
      <div class="menu-list">
        <div
          @click="jump(item.path)"
          v-for="(item, index) in menuArr"
          :key="index"
          class="list-item"
        >
          <span class="">{{ item.name }}</span>
          <span class="item_line"></span>
          <span class="enName">{{ item.enName }}</span>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      menuArr: [
        {
          name: "首页",
          path: "/",
          enName: "HOME",
        },
        {
          name: "管道",
          path: "/TianYuanHome",
          enName: "PIPELINE",
        },
        {
          name: "地板",
          path: "/FloorHome",
          enName: "FLOOR",
        },
        {
          name: "案例",
          path: "/listOfCases",
          enName: "LIST OF CASES",
        },
        {
          name: "新闻",
          path: "/news",
          enName: "NEWS",
        },
        {
          name: "服务与支持",
          path: "/server",
          enName: "SERVICE AND SUPPORT",
        },
        {
          name: "营销网络",
          path: "/networkMarket",
          enName: "MARKETING NETWORK",
        },
        {
          name: "关于天亿",
          path: "/about",
          enName: "ABOUT TIANYI",
        },
      ],
      menuState: true,
      tianyuanLogo: require('../assets/components_img/logo.png'),
    };
  },
  methods: {
    //菜单开关
    menuSwitch: function () {
      if (this.menuState) {
        document.querySelector(".menu-content").style.transform =
          "rotateY(0deg) rotateX(0deg) scale(1)";
        document.querySelector(".menu-but").style.transform = "rotateZ(180deg)";
        document.querySelector(".menu-but1").style.cssText =
          "width: 60%; transform: rotateZ(135deg); left: 67%";
        document.querySelector(".menu-but2").style.width = "0";
        document.querySelector(".menu-but3").style.cssText =
          "width: 60%; transform: rotateZ(-135deg); left: 67%";
        this.menuState = false;
      } else {
        document.querySelector(".menu-content").style.transform =
          "rotateY(-120deg) rotateX(90deg) scale(0)";
        document.querySelector(".menu-but").style.transform = "rotateZ(0)";
        document.querySelector(".menu-but1").style.cssText =
          "width: 50%; transform: rotateZ(0) translateX(-50%); left: 50%";
        document.querySelector(".menu-but2").style.width = "50%";
        document.querySelector(".menu-but3").style.cssText =
          "width: 50%; transform: rotateZ(0) translateX(-50%); left: 50%";
        this.menuState = true;
      }
    },
    //关闭
    jump: function (path) {
      if (path === "/about") {
        this.$router.push({
          path: path,
          query: {
            activeIndex: 0,
          },
        });
      } else {
        this.$router.push({
          path: path,
        });
      }

      if (!this.menuState) {
        this.menuSwitch();
      }
    },
  },
  computed: {
    setlogoFlag() {
      return this.$store.state.logoFlag;
    },
  },
  watch:{
    setlogoFlag(val){
      console.log(val)
      if(val){
      this.tianyuanLogo = require('../assets/indexImg/black_logo.png')
      }else{
      this.tianyuanLogo = require('../assets/components_img/logo.png')
      }
    }
  }
};
</script>

<style scoped lang="scss">
.menu-box {
  width: 100%;
  background-color: #1a1a1a;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  min-width: 1200px;
  .header {
    width: 100%;
    min-height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    .center_box {
      height: 38px;
      width: 92%;
      display: flex;
      justify-content: space-between;
      .logo_floor {
        width: 240px;
        height: 38px;
        cursor: url("../assets/cursor.png"), auto;
      }
      .logo {
        width: 240px;
        height: 38px;
        cursor: url("../assets/cursor.png"), auto;
      }
      .menu-but {
        width: 90px;
        height: 40px;
        border-radius: 50%;
        position: absolute;
        right: 4%;
        z-index: 100;
        background-color: transparent;
        cursor: url("../assets/cursor.png"), auto;
        .menu-but1,
        .menu-but2,
        .menu-but3 {
          display: block;
          width: 50%;
          height: 3px;
          background-color: white;
          position: absolute;
          left: 50%;
          transform-origin: 5% 50%;
          transform: translateX(-50%);
          top: 1.3px;
          transition: all 0.3s;
        }
        .menu-but2 {
          top: auto;
          bottom: 20px;
          color: #ffffff;
        }
        .menu-but3 {
          top: auto;
          bottom: 1.2px;
          color: #ffffff;
        }
      }
    }
  }

  /*导航盒子*/
  .menu-content {
    width: 100vw;
    height: 100vh;
    background-color: #1a1a1a;
    background-image: url("../assets/components_img/header_backimg.png");
    background-size: cover;
    transform-origin: 90% 10%;
    transform: rotateY(-120deg) rotateX(90deg) scale(0);
    position: absolute;
    transition: all 0.7s;
    overflow: hidden;
    .spot {
      position: absolute;
      top: 10%;
      left: 10%;
      opacity: 0.06;
      animation: change 30s infinite alternate linear;
    }

    /*列表页面*/
    .menu-list {
      width: 100%;
      height: 86%;
      padding: 11vh 0 0 0;
      position: relative;
      z-index: 100;
      transition: all 0.5s;
      .list-item {
        width: auto;
        border-bottom: 1px solid #ffffff;
        transition: all 0.3s;
        height: 11vh;
        position: relative;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 110px;
        color: rgba(255, 255, 255, 0.6);
        letter-spacing: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: url("../assets/cursor.png"), auto;
        .item_line {
          width: 0;
          height: 2px;
          background-color: #ffffff;
          display: inline-block;
          transition: all 0.5s;
        }
        .enName {
          width: 0;
          overflow: hidden;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 58px;
          color: #ffffff;
          display: inline-block;
          opacity: 0;
          margin-left: 20px;
          transition: all 0.5s;
        }
      }
      .list-item:hover {
        border-bottom: 1px solid #0fffff;
        background-color: rgba(15, 255, 255, 0.1);
      }
      .list-item:hover > .item_line {
        width: 120px;
        height: 2px;
        background-color: #ffffff;
        display: inline-block;
        transition: all 0.5s;
      }
      .list-item:hover > .enName {
        width: auto;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 58px;
        color: #ffffff;
        opacity: 1;
        transition: all 0.5s;
      }
    }
  }
}
</style>



